import { OrderDirection } from "_shared/_api/ordering/order-direction";
import { parseOrThrow } from "_shared/_utilities/zod-schema-parser";
import { NotificationOrderField } from "notifications/entities/notification/api/request-contracts/notification-query";
import { z } from "zod";

export type NotificationorderParameters = z.infer<typeof NotificationOrderSchema.NotificationOrderZ>;

export default class NotificationOrderSchema {
  public static readonly NotificationOrderZ = z
    .object({
      orderBy: z.enum(NotificationOrderField).optional(),
      orderDir: z.enum(OrderDirection).optional(),
    })
    .optional();

  public static create(values: NotificationorderParameters): NotificationorderParameters {
    return parseOrThrow(NotificationOrderSchema.NotificationOrderZ, values, {
      logError: true,
      schemaName: "NotificationOrderSchema",
      operation: "create",
      payloadSample: values,
    });
  }
}
